<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select
        v-model="query.fState"
        placeholder="状态"
        style="width: 150px"
        size="small"
        clearable
      >
        <el-option value="正常" />
        <el-option value="停用" />
      </el-select>
      <el-input
        v-model="query.fNumber"
        placeholder="产品编码"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fName"
        placeholder="产品名称"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fStockName"
        placeholder="仓库名称"
        size="small"
        style="width: 200px"
        clearable
      />

      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        v-if="canAdd"
        type="primary"
        size="small"
        @click="_modify(null)"
      >新增</el-button>
      <el-button-export :url="downloadUrl" type="primary" size="small">导出</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fNumber" label="产品编码" />
        <el-table-column prop="fName" label="产品名称" />
        <el-table-column prop="fStockName" label="仓库" />
        <el-table-column prop="fModel" label="规格" />
        <el-table-column prop="fUnit" label="单位" />
        <el-table-column prop="fValidity" label="有效期(月)" />
        <el-table-column prop="fRegisterNumber" label="注册号" />
        <el-table-column prop="fSupplier" label="供应商" />
        <el-table-column prop="prohibitTime" label="停产日期" />
        <el-table-column prop="createTime" label="创建日期" />
        <el-table-column label="操作" class-name="table-oper-col" width="120px">
          <template slot-scope="scope">
            <template>
              <el-button
                type="text"
                size="small"
                @click="_modify(scope.row)"
              >查看</el-button>
            </template>
            <template>
              <el-button
                v-if="canAdd"
                type="text"
                size="small"
                @click="_copy(scope.row)"
              >复制</el-button>
            </template>
            <template>
              <ConfirmButton
                v-if="canDel"
                @confirm="_delete(scope.row)"
              >删除</ConfirmButton>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import EditForm from './EditForm'
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    EditForm,
    ConfirmButton
  },
  data() {
    return {
      query: {
        fName: null,
        fNumber: null,
        fStockName: null,
        fState: null,

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,

      tableData: [],
      loading: false,
      currentEditItem: null,
      canAdd: true,
      canEdit: true,
      canDel: true
    }
  },
  mounted() {
    this.refresh()

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '002001002') {
        this.canAdd = val.isGrant
      }
      if (val.key == '002001003') {
        this.canEdit = val.isGrant
      }
      if (val.key == '002001004') {
        this.canDel = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('ICItemManage/ICItem/ICItemEntry', this.query).then(
        (res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }

          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        }
      )
        .finally(() => this.loading = false)
    },
    _modify: async function(row) {
      const isNew = !row
      if (isNew) {
        this.currentEditItem = { fProhibit: false, fPrice: 0, fIsMonthDisplay: false }
      } else {
        this.currentEditItem = await this.$httpPost(
          'ICItemManage/ICItem/GetICItem',
          { fid: row.ficItemID }
        ).then((res) => res.datalist)
      }
      let or
      if (isNew) {
        or = this.canAdd
      } else {
        or = this.canEdit
      }
      const h = this.$createElement
      this.$formDlg({
        title: isNew ? '新建产品' : `查看产品`,
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(isNew, formData),
        width: '90%',
        readonly: !or
      })
    },
    _copy: async function(row) {
      this.currentEditItem = await this.$httpPost(
        'ICItemManage/ICItem/GetICItem',
        { fid: row.ficItemID }
      ).then((res) => res.datalist)

      this.currentEditItem.ficItemID = 0
      this.currentEditItem.fNumber = ''
      this.currentEditItem.fProhibit = false
      this.currentEditItem.pictureUrl = ''

      const h = this.$createElement
      this.$formDlg({
        title: '新建产品',
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(true, formData),
        width: '90%',
        readonly: false
      })
    },
    _delete(row) {
      this.loading = true
      return this.$httpPost(`ICItemManage/ICItem/DeleteICItem`, {
        fid: row.ficItemID
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.loading = false
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    postData(isNew, data) {
      return this.$httpPostFile2(
        `ICItemManage/ICItem/${isNew ? 'Add' : 'Modify'}ICItem`,
        {
          datalist: JSON.stringify(data.data)
        },
        { file: data.file }
      ).then(async(res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'Download/ICItemEntryDownload',
        this.queryParam(true)
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        // if (rtn.startGroupNumber == "") rtn.startGroupNumber = null;
        // if (rtn.endGroupNumber == "") rtn.endGroupNumber = null;
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    }
  }
}
</script>
